import React from 'react';
import { Header } from './components/Header';
import { Home } from './components/Home';
import { About } from './components/About';
import { Services } from './components/Services';
import { SpecializedServices } from './components/SpecializedServices';
import { HelpInfo } from './components/HelpInfo';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
export function App() {
  return <div className="flex flex-col min-h-screen bg-white" data-id="element-0">
      <Header data-id="element-1" />
      <main className="flex-grow" data-id="element-2">
        <Home data-id="element-3" />
        <Services data-id="element-4" />
        <About data-id="element-5" />
        <SpecializedServices data-id="element-6" />
        <HelpInfo data-id="element-7" />
        <Contact data-id="element-8" />
      </main>
      <Footer data-id="element-9" />
    </div>;
}